import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import GetTheComapnyBoywithpinacular from "../../assets/images/boywithpinacular.png";
import { ReactComponent as Image } from "../../assets/images/getthecompany.svg";
import { useSelector } from "react-redux";
import { DESIGNATION_MAX_LENGTH, validateDesignation } from "../../utils/designation";

export const GetTheCompany = ({
  des,
  button,
  fromBanner,
  company,
  company_id,
  SubscriptionActive,
  handlePurchased,
  handleGetCompany,
  createWorldBoxOrder,
  isContinue,
  secondayListedHandler,
  acknowledgement,
  formData,
  setFormData,
}) => {
  const navigate = useNavigate();
  const { userInfo, isLoggedIn, token } = useSelector((state) => state.auth);
  const { id } = useParams();

  const [isAcknowledged, setIsAcknowledged] = useState(false);

  useEffect(() => {
    const formObject = formData || {};
    const isAnyFieldFilled = Object.values(formObject).some((value) => value.trim());

    if (isAnyFieldFilled && !isAcknowledged) {
      setIsAcknowledged(true);
    }
  }, [formData, isAcknowledged]);

  const handleNavigate = () => {
    window.scrollTo(0, 0);
    navigate("/plans", {
      state: { company_id: id },
    });

  };

  const designationError = isAcknowledged && (formData.designation || '').trim() !== ''
    ? validateDesignation(formData.designation)
    : null;

  const isFormIncomplete = isAcknowledged && (
    !formData.name || !formData.designation || !formData.email ||
    formData.name.trim() === '' || formData.designation.trim() === '' || formData.email.trim() === '' ||
    Boolean(designationError)
  );

  const handleAcknowledgementChange = (e) => {
    const isChecked = e.target.checked;
    setIsAcknowledged(isChecked);

    // If the checkbox is being unchecked, clear the form data
    if (!isChecked) {
      setFormData({
        name: '',
        designation: '',
        email: '',
        contactNumber: '',
      });
    }
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleClick = (e) => {
    if (isContinue) {
      secondayListedHandler();
    } else {
      SubscriptionActive ? handlePurchased() : company?.claimed
        ? handleGetCompany()
        : createWorldBoxOrder(formData)
    }
  }
  return (
    <div className="text-center flex flex-col items-center">
      {fromBanner ? (
        <img src={GetTheComapnyBoywithpinacular} style={{ width: '100px', padding: '10px' }} alt="GetTheBusiness" />
      ) : (
        <Image />
      )}
      <h3 className="text-secondarytwo text-left text-f20 font-semibold">
        Get The Business
      </h3>
      <p className="text-secondary pt-2 pb-4 w-80 text-f14">{des}</p>
      {
        acknowledgement && (
          <>
            {/* items-start, not the default stretch: the label wraps to two
                lines, and a centred box drifts off the first line it belongs
                to. mt-[2px] sits it on that line's optical centre. */}
            <div className="flex items-start gap-3 w-80 pb-4 text-left">
              <input
                type="checkbox"
                checked={isAcknowledged}
                onChange={handleAcknowledgementChange}
                id="acknowledgementCheckbox"
                /* shrink-0 keeps the box square — in a flex row a long label squashes a native checkbox into a rectangle. */
                className="mt-[2px] h-4 w-4 shrink-0 cursor-pointer accent-primary rounded"
              />
              <label
                className="text-secondary text-f12 cursor-pointer leading-[1.5]"
                htmlFor="acknowledgementCheckbox"
              >
                Can we contact a business representative using your provided details to create a detailed report?
              </label>
            </div>
            {isAcknowledged && (
              <div className="form">
                <input
                  type="text"
                  className="text-secondary pt-2 pb-4 w-80 text-f14"
                  value={formData.name}
                  onChange={handleFormChange}
                  name="name"
                  placeholder="Name"
                /><br />
                <input
                  type="text"
                  className="text-secondary pt-2 pb-4 w-80 text-f14"
                  value={formData.designation}
                  onChange={handleFormChange}
                  name="designation"
                  maxLength={DESIGNATION_MAX_LENGTH}
                  placeholder="Designation"
                /><br />
                {designationError && (
                  <p className="text-red-500 text-sm text-left">{designationError}</p>
                )}
                <input
                  type="email"
                  className="text-secondary pt-2 pb-4 w-80 text-f14"
                  value={formData.email}
                  onChange={handleFormChange}
                  name="email"
                  placeholder="Email Address"
                /><br />
                <input
                  type="tel"
                  className="text-secondary pt-2 pb-4 w-80 text-f14"
                  value={formData.contactNumber}
                  onChange={handleFormChange}
                  name="contactNumber"
                  placeholder="Contact Number (optional)"
                /><br />
              </div>
            )}
          </>
        )
      }
      <hr />
      <button
        onClick={handleClick}
        className={`bg-primary px-4 py-3 text-white text-f14 font-semibold rounded w-full transition-colors ${isFormIncomplete ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-[#e04524]'}`}
        disabled={isFormIncomplete}
      >
        {button}
      </button>
      <div className="flex justify-between text-secondary pt-4 items-center"></div>
    </div>
  );
};
